/**
 * @generated SignedSource<<6a614ff9cb66cc1abbd9b42133cbb837>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type NudgeRequesteesMutation$variables = {
  id: string;
  requestees: ReadonlyArray<string | null>;
};
export type NudgeRequesteesMutation$data = {
  readonly nudgeRequestees: {
    readonly requests: ReadonlyArray<{
      readonly id: string;
    }>;
  } | null;
};
export type NudgeRequesteesMutation = {
  response: NudgeRequesteesMutation$data;
  variables: NudgeRequesteesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "requestees"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "requestees",
        "variableName": "requestees"
      }
    ],
    "concreteType": "NudgeRequestees",
    "kind": "LinkedField",
    "name": "nudgeRequestees",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FeedbackRequestNode",
        "kind": "LinkedField",
        "name": "requests",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NudgeRequesteesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NudgeRequesteesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "de0d5bb66cc30459cb8aa17b4cbd16c7",
    "id": null,
    "metadata": {},
    "name": "NudgeRequesteesMutation",
    "operationKind": "mutation",
    "text": "mutation NudgeRequesteesMutation(\n  $id: ID!\n  $requestees: [ID]!\n) {\n  nudgeRequestees(id: $id, requestees: $requestees) {\n    requests {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a8dafbaf2da1a97692edd547ebfd5eaa";

export default node;
